import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { localeConfig, supportedLanguages } from '../i18n/locales';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const currentLang = i18n.language || 'th';
  const currentLocale = localeConfig[currentLang] || localeConfig['th'];

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setIsOpen(false);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-2 sm:px-3 py-1 sm:py-2 rounded-lg hover:bg-gray-100 transition text-xs sm:text-sm text-gray-800 font-medium w-full"
        aria-label="Change language"
      >
        <span className="text-base sm:text-lg">{currentLocale.flag}</span>
        <span className="hidden sm:inline text-xs font-mono text-gray-600 mr-1">{currentLocale.code}</span>
        <span className="flex-1 text-left">{currentLocale.nativeName}</span>
        <span className="text-xs text-gray-600">▼</span>
      </button>
      
      {isOpen && (
        <div className="absolute top-full right-0 rtl:right-auto rtl:left-0 mt-2 bg-white rounded-lg shadow-lg border border-gray-200 z-50 min-w-[180px] max-h-[400px] overflow-y-auto">
          {supportedLanguages.map((lng) => {
            const locale = localeConfig[lng];
            const isSelected = currentLang === lng;
            return (
              <button
                key={lng}
                onClick={() => changeLanguage(lng)}
                className={`w-full text-left rtl:text-right px-4 py-2 flex items-center gap-2 transition ${
                  isSelected 
                    ? 'bg-blue-100 text-blue-800 font-semibold' 
                    : 'text-gray-800 hover:bg-gray-100 hover:text-gray-900'
                }`}
              >
                <span className="text-lg">{locale.flag}</span>
                <span className="text-xs font-mono text-gray-500 mr-1">{locale.code}</span>
                <span className={isSelected ? 'font-semibold' : 'font-normal'}>{locale.nativeName}</span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;

